import { pxToRem } from "../../../utills/pxToRem";
import { fonts } from "../../foundations/fonts";

export default {
    parts: ['container', 'list', 'listItem', 'listItemSx', 'heading', 'menuItemDivider', 'back'],
    baseStyle: {
        container: {
            color: 'white',
            marginTop: [2, 2, 0, 0],
            marginBottom: [0, 0, 0, 0]
        },
        list: {
            fontSize: 'sm'
        },
        headingLink: {
            display: 'flex',
            fontFamily: fonts.primary,
            fontWeight: '400',
            textDecoration: 'none',
            marginTop: [0, 0, 1, 1],
            marginBottom: [0, 0, 2, 2],
            lineHeight: pxToRem(18),
            alignItems: 'center',
            justifyContent: 'space-between',
            borderBottom: [`${pxToRem(1)} solid #1a1a1a`, `${pxToRem(1)} solid #1a1a1a`, `${pxToRem(0)} solid #1a1a1a`, `${pxToRem(0)} solid #1a1a1a`],     // using hexa code as a value for border color because it used only here
            borderRadius: '0',
        },
        heading: {
            paddingTop: 3,
            paddingBottom: 3,
            color: 'black',
            textTransform: 'uppercase',
            letterSpacing: pxToRem(3),
            fontFamily: "Montserrat",
            fontWeight: '400',
            marginTop: [0, 0, 1, 1],
            marginBottom: [0, 0, 2, 2],
            marginRight: [0, 0, 5, 5],
            lineHeight: pxToRem(18),
            wordWrap: 'break-word',
            whiteSpace: 'normal',
            overflowWrap: 'break-word',
            textAlign: 'left'
        },
        menuItemDivider: {
            marginBottom: [2, 2, 0, 0],
            marginTop: [0],
            borderColor: 'black'
        },
        back: {
            display: 'flex',
            alignItems: 'center',
            borderBottom: `${pxToRem(3)} solid black}`
        }
    },
    variants: {
        vertical: {},
        horizontal: {
            list: {
                display: 'flex',
                flexDirection: 'row',
                gap: '0.5rem'
            },
            listItem: {
                borderLeft: '1px solid',
                paddingLeft: 2
            },
            listItemSx: {
                '&:first-of-type': {
                    borderLeft: 0,
                    paddingLeft: 0
                }
            }
        }
    },
    defaultProps: {
        variant: 'vertical'
    }
}
